import React from "react";
import * as S from "./styled";
import Breadcrumbs, { BreadcrumbItemType } from "@app/components/ui/breadcrumbs";
import { useTranslation } from "next-i18next";
import BackgroundImageTablet from "@app/images/contacts-tablet.jpg";
import BackgroundImageMobile from "@app/images/contacts-mobile.png";

const Contacts: React.FC = () => {
  const { t } = useTranslation();
  const BREADCRUMBS: BreadcrumbItemType[] = [
    {
      title: "Контакты",
      url: "/contacts",
    },
  ];

  const brandPhones = [
    {
      name: "AM.PM",
      phone: "8-800-200-29-29"
    },
    {
      name: "Damixa",
      phone: "8-800-533-96-30"
    },
    {
      name: "Dorff",
      phone: "8-800-533-96-03"
    },
  ]

  return (
    <S.Container>

      <S.Wrap>
        <Breadcrumbs items={BREADCRUMBS} />
        <S.HeaderPageWrap>
          <S.Title>{t("common:navigation.contacts")}</S.Title>
        </S.HeaderPageWrap>
        <S.ContentWrap>
          <S.InfoWrap>
            <S.ServiceWrap>
              <S.RegionNameWrap>
                {brandPhones.map((phone, idx) => (
                    <S.PhoneInfo key={idx}>
                      <S.BrandNumber>{phone.name}</S.BrandNumber>
                      <S.NumberInfo>{phone.phone}</S.NumberInfo>
                    </S.PhoneInfo>
                ))}
                <S.ServiceList>
                </S.ServiceList>
              </S.RegionNameWrap>
            </S.ServiceWrap>
          </S.InfoWrap>
        </S.ContentWrap>
      </S.Wrap>
      <S.BackgroundImageDesktop src={BackgroundImageTablet} alt={"Фоновое изображение"}/>
      <S.BackgroundImageTablet src={BackgroundImageTablet} alt={"Фоновое изображение"}/>
      <S.BackgroundImageMobile src={BackgroundImageMobile} alt={"Фоновое изображение"}/>
    </S.Container>
  );
};

export default Contacts;
